import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { BLOG_POSTS } from "@/data/siteData";
import { BLOG } from "@/constants/testIds";
import SEO from "@/components/SEO";

export default function BlogList() {
  return (
    <main data-testid={BLOG.list} className="pt-28">
      <SEO
        title="Blog — Approfondimenti di gastroenterologia"
        description="Articoli e approfondimenti su sintomi digestivi, esami e patologie dell'apparato digerente. Contenuti curati dal Dr. Cristian Santus."
        path="/blog"
      />
      <section className="py-16 md:py-24 bg-[#F9FAFB]">
        <div className="max-w-6xl mx-auto px-6 md:px-10">
          <p className="overline">Blog</p>
          <h1 className="font-serif text-4xl md:text-6xl mt-4 text-[#0B4A5A] leading-[1.05] max-w-3xl">
            Approfondimenti di gastroenterologia.
          </h1>
          <p className="mt-6 text-gray-600 leading-relaxed max-w-2xl">
            Contenuti divulgativi curati per aiutarti a capire meglio i sintomi
            digestivi, gli esami e le principali patologie.
          </p>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-6xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
            {BLOG_POSTS.map((post) => (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                data-testid={BLOG.card(post.slug)}
                className="group"
              >
                <div className="overflow-hidden rounded-2xl bg-gray-100 aspect-[16/10]">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    loading="lazy"
                  />
                </div>
                <div className="mt-6">
                  <div className="flex items-center gap-3 text-xs">
                    <span className="uppercase tracking-[0.18em] text-[#C6A86B] font-medium">
                      {post.category}
                    </span>
                    <span className="text-gray-400">·</span>
                    <span className="text-gray-500">{post.date}</span>
                    <span className="text-gray-400">·</span>
                    <span className="text-gray-500">{post.readTime}</span>
                  </div>
                  <h2 className="font-serif text-2xl md:text-3xl mt-3 text-[#0B4A5A] leading-tight group-hover:text-[#0D5E73] transition-colors">
                    {post.title}
                  </h2>
                  <p className="mt-3 text-gray-600 leading-relaxed">
                    {post.excerpt}
                  </p>
                  <div className="mt-5 inline-flex items-center gap-1.5 text-sm text-[#0B4A5A] font-medium">
                    Leggi l'articolo
                    <ArrowUpRight
                      size={14}
                      className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                    />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
